const getTopPositionForElement = (selectorOrElement: string | Element | null) => {
  const element =
    typeof selectorOrElement === 'string'
      ? document.querySelector(selectorOrElement)
      : selectorOrElement;

  return element?.getBoundingClientRect().top ?? 0;
};

export const scrollToElement = (
  selectorOrElement: string | Element | null,
  marginTop: number = 20,
  behavior: ScrollBehavior = 'smooth',
  isHeaderVisible: boolean = true,
) => {
  const elementTopPosition = getTopPositionForElement(selectorOrElement);
  const mainContentTopPosition = isHeaderVisible ? getTopPositionForElement('.etiMainContent') : 0;
  const scrollTopPosition = elementTopPosition - mainContentTopPosition - marginTop;
  const isScrollBehaviorSupported = 'scrollBehavior' in document.documentElement.style;

  if (isScrollBehaviorSupported) {
    window.scrollTo({
      top: scrollTopPosition,
      behavior,
    });
  } else {
    window.scrollTo(0, scrollTopPosition);
  }
};

export const scrollToAndFocusOnFirstError = () => {
  const firstLabelWithError = document.querySelector(
    'label:has(~*>input[aria-invalid="true"], ~*>.error), input[aria-invalid="true"], .error',
  );

  if (firstLabelWithError instanceof HTMLElement) {
    firstLabelWithError.scrollIntoView({ block: 'center', behavior: 'smooth' });
    firstLabelWithError.focus({ preventScroll: true });
  }
};
